import { useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Mail, Check } from "lucide-react";
import { toast } from "sonner";
import { track } from "@/lib/analytics";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterSignup({ tags = [], variant = "inline" }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const clean = email.trim().toLowerCase();
    if (!clean || !clean.includes("@")) return toast.error("Enter a valid email");
    setBusy(true);
    try {
      await axios.post(`${API}/subscribe`, {
        email: clean,
        source_page: window.location.pathname,
        marketing_consent: true,
        tags,
      });
      track("newsletter_signup", { target_label: clean, meta: { source_page: window.location.pathname } });
      setDone(true);
      setEmail("");
      toast.success("You're on the list.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Signup failed");
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div data-testid="newsletter-success" className="flex items-center gap-2 text-[#D4AF37] text-sm">
        <Check className="w-4 h-4" /> You're on the list — watch your inbox for drops.
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="flex gap-2 max-w-md w-full">
      <div className="relative flex-1">
        <Mail className="w-4 h-4 text-white/30 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
        <input
          data-testid="newsletter-email-input"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="w-full bg-[#0A0A0A] border border-white/10 pl-10 pr-3 py-3 rounded text-sm text-white outline-none focus:border-[#D4AF37] placeholder:text-white/25"
        />
      </div>
      <Button
        data-testid="newsletter-submit"
        type="submit"
        disabled={busy}
        className={`bg-[#D4AF37] text-black hover:bg-white font-semibold uppercase tracking-wider text-xs px-6 ${variant === "compact" ? "h-11" : ""}`}
      >
        {busy ? "…" : "Join"}
      </Button>
    </form>
  );
}
